export const videoPlayerBlockDeriveProps = [];
